import { j as o } from "./atoms-v218.js";
import { useRef as n, useEffect as u } from "react";
import { CalendarMonth as p } from "./atoms-v2765.js";
import { useCalendarContext as f } from "./atoms-v2766.js";
import { Wrapper as c, ContentList as d } from "./atoms-v2767.js";
import { getScrollToPosition as h } from "./atoms-v2768.js";
import { useDataPreloader as x } from "./atoms-v2769.js";
function T({ colorTheme: a = "light" }) {
  const t = n(null), e = n({}), { domBuilder: l, userInteractions: s } = f();
  return u(() => {
    var r;
    (r = t.current) != null && r.scrollTo && t.current.scrollTo({
      top: h(t, e, s.startingCell)
    });
  }, []), x(), /* @__PURE__ */ o.jsx(c, { "aria-label": "Calendar", ref: t, children: /* @__PURE__ */ o.jsx(d, { children: l.calendarYearConfigs.map((r, i) => /* @__PURE__ */ o.jsx(
    p,
    {
      colorTheme: a,
      monthConfig: r.month,
      ref: (m) => e.current[r.month.monthUID] = m,
      yearValue: r.value
    },
    i
  )) }) });
}
export {
  T as CalendarList
};
